var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade-to-top", appear: "" } }, [
    _c(
      "div",
      { staticClass: "billing-section" },
      [_c("Dashboard-BillingWidget")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }